// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"88445302","453":"25426bc6","732":"ff9d6d1f","977":"382c2d7f"}[chunkId] + ".chunk.js";
};